<form [formGroup]="remarkForm" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>{{ data?.title || "Enter Remark" }}</h2>
  
  <div style="padding: 20px 24px;">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Remark</mat-label>
      <textarea 
        matInput 
        formControlName="remark"
        rows="4"
        placeholder="Enter your remark here...">
      </textarea>
      <mat-error *ngIf="remarkForm.get('remark')?.hasError('required')">
        Remark is required
      </mat-error>
    </mat-form-field>
  </div>

  <div style="display: flex; justify-content: flex-end; gap: 8px; padding: 16px 24px; border-top: 1px solid #e0e0e0;">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      type="submit"
      [disabled]="!remarkForm.valid">
      Submit
    </button>
  </div>
</form>